import { render, staticRenderFns } from "./VsButtonToggle.vue?vue&type=template&id=16f5622a&lang=pug&"
import script from "./VsButtonToggle.vue?vue&type=script&lang=js&"
export * from "./VsButtonToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f5622a')) {
      api.createRecord('16f5622a', component.options)
    } else {
      api.reload('16f5622a', component.options)
    }
    module.hot.accept("./VsButtonToggle.vue?vue&type=template&id=16f5622a&lang=pug&", function () {
      api.rerender('16f5622a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsButtonToggle.vue"
export default component.exports